<template lang="pug">
liondesk-dialog-v2(
  v-model="value"
  rounded
  hide-cancel-button
  width="750px"
  ok-button-text="Got it"
  @click:ok="$emit('close')"
)
  template(slot="body")
    v-layout.text-xs-left.dialog-body(column)
      div
        h1 What do the error codes for undeliverable email addresses mean?
      div
        span "Email Bounced"
        ul
          li The contact's server refused to receive emails sent from your email address.
      div
        span "Email Invalid"
        ul
          li The contact's email address might not exist anymore, or it may have been entered incorrectly.
      div
        span "Email Reported as Spam"
        ul
          li The contact indicated that an email you sent looked suspicious and reported it as spam.
      div
        span "Email Unsubscribed"
        ul
          li The contact has unsubscribed to your email communications.
      div
        h1 What can you do?
      div
        v-layout(column)
          span If the status shows "Unsubscribed", you can resubscribed the address under certain conditions. 
            a(href="https://lonewolf.my.site.com/s/article/LD-Resubscribe-a-contact-LionDesk" target="_blank") Learn how to here.
          span For all other statuses, if you believe the status was set in error, contact our 
            a(href="mailto:support@liondesk.com") Support 
            | to get help.
</template>

<script>
import LiondeskDialogV2 from '@/Core/components/LiondeskDialogV2';

export default {
  name: 'EmailStatusModal',
  components: {
    LiondeskDialogV2,
  },
  props: {
    value: {
      type: Boolean,
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-body {
  span, li {
    font-size: 16px;
  }
  div:not(:first-child) {
    margin-top: 15px;

    &>span:first-child {
      font-size: 18px;
      letter-spacing: 0.5px;
    }
  }
}
</style>
